<!-- =========================================================================================
  Dosya Adı   : GuideButton.vue
  Açıklama    : Navbar'a gömülen "Kılavuz" butonu. Her sayfada görünür; tıklanınca
                aktif sayfanın ($route.name) kılavuzunu GuideModal içinde açar.
                İçerik backend'den çekilir (admin yükler, herkes görür).
========================================================================================== -->

<template>
  <div class="guide-button-wrapper">
    <feather-icon
      icon="HelpCircleIcon"
      class="cursor-pointer ml-4"
      :svgClasses="['stroke-current text-primary', 'h-6 w-6']"
      @click.stop="showGuide = true"
      v-b-tooltip.hover.bottom="'Kılavuz'"
    />

    <guide-modal :active.sync="showGuide" />
  </div>
</template>

<script>
import GuideModal from "./GuideModal.vue";

export default {
  name: "guide-button",
  components: {
    GuideModal
  },
  data() {
    return {
      showGuide: false
    };
  },
  watch: {
    // Sayfa değişince açık modalı kapat
    $route() {
      this.showGuide = false;
    }
  }
};
</script>
